
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"240","height":"240","viewBox":"0 0 63.5 63.5"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(0 -233.5)"}},[_c('path',{attrs:{"d":"M44.783 273.047l-8.08-21.64M22.955 280.44L18.5 265.396","fill":"none","stroke":"#e0e0e0","stroke-width":".265"}}),_c('path',{attrs:{"d":"M12.253 257.81l-7.063 4.512 7.394 24.261 10.37-6.142 13.23.52 8.599-7.914 13.229-.922-9.993-20.434-11.315-.283-8.08 6.638-3.047-.402","fill":"none","stroke":"#3a3a3a","stroke-width":"1.6"}}),_c('path',{attrs:{"d":"M28.624 258.046l7.56 22.915","fill":"none","stroke":"#3a3a3a","stroke-width":"1.058"}}),_c('path',{attrs:{"d":"M19.07 242.71a7.844 7.844 0 00-7.844 7.843c0 .503.033.997.137 1.47.561 2.55 3.179 5.333 7.27 12.335.388.562.43.64.799.013 4.179-6.887 6.755-10.24 7.385-12.594.104-.39.095-.807.095-1.224a7.843 7.843 0 00-7.843-7.843zm.024 2.73a4.337 4.337 0 014.338 4.338 4.337 4.337 0 01-4.338 4.337 4.337 4.337 0 01-4.337-4.337 4.337 4.337 0 014.337-4.338z","fill":"#3a3a3a","paint-order":"stroke fill markers"}}),_c('path',{attrs:{"d":"M47.506 264.1c-2.158-3.276-10.35-5.125-16.16 2.057-5.812 7.181-2.316 5.071-6.934 8.97-5.055 4.266-9.998-4.042-9.998-4.042","fill":"none","stroke":"#3a3a3a","stroke-width":"1.1","stroke-dasharray":"2.19999996,2.19999996"}}),_c('circle',{attrs:{"cx":"12.714","cy":"269.422","r":"1.85","fill":"none","stroke":"#3a3a3a","stroke-width":"1.1","stroke-linecap":"square","paint-order":"stroke fill markers"}}),_c('circle',{attrs:{"r":"1.85","cy":"267.469","cx":"49.062","fill":"#3a3a3a","stroke":"#3a3a3a","stroke-width":"1.1","stroke-linecap":"square","paint-order":"stroke fill markers"}})])])
          )
        }
      }
    